import { format, parseISO, subWeeks } from 'date-fns';
import { localeFormatterHelper } from '../../../../../../shared/helpers/formatter/localeFormatter.helper.ts';

export const MAX_COMPARISON_DATES = 3;
export const COMPARISON_FIELD_PREFIX = 'comparison_';

export const comparisonChipColors = {
  ordered: '#2F6BFF',
  sold: '#FFB300',
  returned: '#F44336',
} as const;

export const COMPARISON_HEADER_BG = '#EDE7F6';

export type TComparisonMetric = 'ordered' | 'sold' | 'returned';
export const COMPARISON_METRIC_ORDER: TComparisonMetric[] = ['ordered', 'sold', 'returned'];

export type TComparisonMetricValues = {
  ordered: number | null;
  sold: number | null;
  returned: number | null;
};

export type IComparisonMetricsByKey = Record<string, TComparisonMetricValues>;

export type TComparisonFailure = 'timedOut' | 'error';
export type TComparisonFailedDates = Record<string, TComparisonFailure>;

export interface IComparisonDateRequest {
  comparisonDate: string;
  articleIds: string[];
}
export interface IComparisonMetricsParams {
  customerId: string;
  requests: IComparisonDateRequest[];
}
export interface IComparisonDateResult {
  customerId: string;
  comparisonDate: string;
  articleIds: string[];
  byKey: IComparisonMetricsByKey;
  failure?: TComparisonFailure;
}

// Local response type — the query isn't in generatedModel.ts yet (codegen needs backend access).
export interface IComparisonMetricRow {
  articleId: string;
  ordered: number | null;
  sold: number | null;
  returned: number | null;
}
export interface IListComparisonMetricsQuery {
  wawiAssist?: {
    listWA_OrderArticlesComparisonMetrics?: IComparisonMetricRow[] | null;
  } | null;
}

export const buildComparisonKey = (
  customerId: string | null | undefined,
  date: string,
  articleId?: string | null,
): string => `${customerId ?? ''}__${date}__${articleId ?? ''}`;

export const getDefaultComparisonDate = (orderDate?: string | Date | null): string | undefined => {
  if (!orderDate) return undefined;
  const base = typeof orderDate === 'string' ? parseISO(orderDate) : orderDate;
  if (Number.isNaN(base?.getTime?.())) return undefined;
  return format(subWeeks(base, 1), 'yyyy-MM-dd');
};

export const formatComparisonValue = (value: number | null | undefined): string => {
  if (value == null) return '-';
  return localeFormatterHelper.formatNumber(value, {
    returnZero: true,
    noTrailingZeros: true,
    precision: 3,
  });
};
